const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValorAutomatico(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "master-artboard",
    viewBox: "0 0 503.5628967285156 446.98333740234375",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1400 980"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.450656771659851, 0, 0, 0.450656771659851, 6.28594971711459, -3.634204098537481)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.343433380126952, 0, 0, 5.343433380126952, 7.972793640204031, 44.3710021972656)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.03664058446884155, 0, 0, 0.03664058446884155, -625.5484771728516, -369.62646484375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-1",
    d: "M19881.07 10344.76c0,98.12 -79.55,177.7 -177.68,177.7 -98.23,0 -177.81,-79.58 -177.81,-177.7 0,-98.13 79.58,-177.71 177.81,-177.71 98.13,0 177.68,79.58 177.68,177.71z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-2",
    d: "M20103.27 10374.02c25.45,-94.78 122.88,-150.97 217.69,-125.63 94.78,25.45 150.97,122.88 125.63,217.69 -25.34,94.78 -122.87,150.97 -217.57,125.63 -94.82,-25.45 -151.09,-122.79 -125.75,-217.69z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-3",
    d: "M20653.76 10551.81c49,-84.95 157.65,-114.02 242.72,-65.02 84.98,49.12 114.13,157.77 65.02,242.73 -49.01,85.06 -157.74,114.13 -242.73,65.12 -84.95,-49.11 -114.13,-157.76 -65.01,-242.83z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-4",
    d: "M21139.31 10866.07c69.45,-69.45 182.02,-69.45 251.36,0 69.44,69.33 69.44,181.9 0,251.27 -69.34,69.33 -181.91,69.33 -251.36,0 -69.36,-69.37 -69.36,-181.94 0,-251.27z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-5",
    d: "M21527.1 11295.24c85.07,-49.12 193.72,-19.97 242.75,65.01 49.09,84.96 19.94,193.61 -65.04,242.72 -84.96,49.12 -193.72,19.94 -242.72,-65.01 -49.12,-84.98 -19.94,-193.72 65.01,-242.72z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-6",
    d: "M21790.65 11810.05c94.81,-25.36 192.24,30.94 217.69,125.72 25.34,94.81 -30.93,192.24 -125.63,217.69 -94.9,25.34 -192.24,-30.93 -217.69,-125.74 -25.42,-94.79 30.85,-192.24 125.63,-217.67z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-7",
    d: "M21911.89 12375.66c98.12,0 177.68,79.55 177.68,177.68 0,98.15 -79.56,177.7 -177.68,177.7 -98.15,0 -177.7,-79.55 -177.7,-177.7 0,-98.13 79.55,-177.68 177.7,-177.68z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-8",
    d: "M21882.71 12953.33c94.7,25.36 150.97,122.9 125.63,217.58 -25.45,94.89 -122.88,151.08 -217.69,125.74 -94.78,-25.45 -151.05,-122.88 -125.63,-217.69 25.45,-94.78 122.79,-151.05 217.69,-125.63z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-9",
    d: "M21704.81 13503.82c84.98,49 114.13,157.65 65.04,242.63 -49.03,85.07 -157.68,114.14 -242.75,65.02 -84.95,-49.01 -114.13,-157.65 -65.01,-242.61 49,-85.09 157.76,-114.16 242.72,-65.04z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-10",
    d: "M21390.67 13989.37c69.44,69.45 69.44,181.91 0,251.38 -69.34,69.34 -181.91,69.34 -251.36,0 -69.36,-69.47 -69.36,-181.93 0,-251.38 69.45,-69.36 182.02,-69.36 251.36,0z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-11",
    d: "M20961.5 14377.19c49.11,84.95 19.96,193.69 -65.02,242.72 -85.07,49.12 -193.72,19.94 -242.72,-65.04 -49.12,-84.96 -19.94,-193.69 65.01,-242.72 84.99,-49.12 193.72,-19.94 242.73,65.04z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-12",
    d: "M20446.59 14640.74c25.34,94.78 -30.85,192.13 -125.63,217.58 -94.81,25.34 -192.24,-30.85 -217.69,-125.75 -25.34,-94.7 30.93,-192.24 125.75,-217.46 94.7,-25.45 192.23,30.74 217.57,125.63z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-13",
    d: "M19881.07 14761.84c0,98.23 -79.55,177.81 -177.68,177.81 -98.23,0 -177.81,-79.58 -177.81,-177.81 0,-98.13 79.58,-177.6 177.81,-177.6 98.13,0 177.68,79.47 177.68,177.6z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-14",
    d: "M18960.08 14640.74c25.34,-94.89 122.88,-151.08 217.69,-125.63 94.67,25.22 151.06,122.76 125.63,217.46 -25.45,94.9 -122.9,151.09 -217.69,125.75 -94.78,-25.45 -150.97,-122.8 -125.63,-217.58z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-15",
    d: "M18445.15 14377.19c49.03,-84.98 157.77,-114.16 242.72,-65.04 84.98,49.03 114.16,157.76 65.05,242.72 -49.01,84.98 -157.66,114.16 -242.64,65.04 -85.07,-49.03 -114.25,-157.77 -65.13,-242.72z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-16",
    d: "M18015.98 13989.37c69.36,-69.36 181.94,-69.36 251.38,0 69.36,69.45 69.36,181.91 0,251.38 -69.44,69.34 -182.02,69.34 -251.38,0 -69.44,-69.47 -69.44,-181.93 0,-251.38z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-17",
    d: "M17701.86 13503.82c84.96,-49.12 193.69,-20.05 242.73,65.04 49.11,84.96 19.93,193.6 -65.05,242.61 -85.06,49.12 -193.69,20.05 -242.72,-65.02 -49.12,-84.98 -19.94,-193.63 65.04,-242.63z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-18",
    d: "M17524.05 12953.33c94.81,-25.42 192.24,30.85 217.58,125.63 25.45,94.81 -30.83,192.24 -125.64,217.69 -94.78,25.34 -192.21,-30.85 -217.66,-125.74 -25.34,-94.68 30.94,-192.22 125.72,-217.58z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-19",
    d: "M17494.78 12375.66c98.13,0 177.71,79.55 177.71,177.68 0,98.15 -79.58,177.7 -177.71,177.7 -98.12,0 -177.7,-79.55 -177.7,-177.7 0,-98.13 79.58,-177.68 177.7,-177.68z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-20",
    d: "M17615.99 11810.05c94.81,25.43 151.09,122.88 125.64,217.67 -25.34,94.81 -122.77,151.08 -217.58,125.74 -94.78,-25.45 -151.06,-122.88 -125.72,-217.69 25.45,-94.78 122.88,-151.08 217.66,-125.72z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-21",
    d: "M17879.54 11295.24c84.98,49 114.16,157.74 65.05,242.72 -49.04,84.95 -157.77,114.13 -242.73,65.01 -84.98,-49.11 -114.16,-157.76 -65.04,-242.72 49.03,-84.98 157.66,-114.13 242.72,-65.01z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-22",
    d: "M18267.36 10866.07c69.36,69.33 69.36,181.9 0,251.27 -69.44,69.33 -182.02,69.33 -251.38,0 -69.44,-69.37 -69.44,-181.94 0,-251.27 69.36,-69.45 181.94,-69.45 251.38,0z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-23",
    d: "M18752.92 10551.81c49.11,85.07 19.93,193.72 -65.05,242.83 -84.95,49.01 -193.69,19.94 -242.72,-65.12 -49.12,-84.96 -19.94,-193.61 65.13,-242.73 84.98,-49 193.63,-19.93 242.64,65.02z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_padrao_grafico_direita",
    name: "automatico-24",
    d: "M19303.4 10374.02c25.43,94.9 -30.96,192.24 -125.63,217.69 -94.81,25.34 -192.35,-30.85 -217.69,-125.63 -25.34,-94.81 30.85,-192.24 125.63,-217.69 94.79,-25.34 192.24,30.85 217.69,125.63z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 18019.46,
    y: 12132.14,
    className: "fil1 fnt2 area_cor_fonte_grafico_direita",
    style: {
      whiteSpace: "pre",
      fill: "rgb(138, 141, 144)",
      fontWeight: "bold",
      fontSize: "512.46px",
      fontFamily: "'Arial'",
      fontWeight: "bold"
    }
  }, "AUTOM\xC1TICO")))), /*#__PURE__*/React.createElement("text", {
    className: "label camada_automatico single-line-text percentuais automatico_total area_cor_valor_automatico",
    dominantBaseline: "middle",
    style: {
      whiteSpace: "pre",
      textAnchor: "middle",
      fill: "rgb(193, 91, 211)",
      fontWeight: "bold",
      fontSize: "203.57px",
      textAlign: "center",
      fontFamily: "Arial",
      color: "rgb(193, 91, 211)"
    },
    x: 710,
    y: 630,
    transform: "matrix(1, 0, 0, 1, -180.04503439523023, 16.36773061418853)",
    name: "automatico_total"
  }, "0")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValorAutomatico);
export default __webpack_public_path__ + "static/media/valor_automatico.6e3cbe5c14f61e8caef84d72abbbc8a3.svg";
export { ForwardRef as ReactComponent };